module.exports = __webpack_public_path__ + "img/marker-red.82bd590c.svg";